import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Public (no-login) property-owner onboarding. No `meta.requiresAuth`, so the
// global guard lets anonymous visitors through — a property owner has no
// SliceAL account in this flow, and the emailed link is the only credential.
//
// The path is not free to change: admin-service builds the invite URL as
// `${SELLER_WEB_BASE_URL}/owners/onboarding/<token>` and mails it. A rename here
// breaks every link already in an owner's inbox.
export const ownerOnboardingRoutes: RouteRecordRaw[] = [
  {
    path: routes.PUBLIC_OWNER_ONBOARDING,
    name: 'PUBLIC_OWNER_ONBOARDING',
    component: () => import('./OwnerOnboardingPage.vue'),
    meta: { title: 'Complete your owner details' },
  },
]
